// src/lib/productStoreUtils.js
// Utility functions for handling store information when creating products

import { db } from './firebase';
import { collection, query, where, limit, getDocs } from 'firebase/firestore';

/**
 * Get the cooperative store ID
 */
export async function getCooperativeStoreId() {
  try {
    const storesRef = collection(db, 'stores');
    const cooperativeQuery = query(
      storesRef,
      where('type', '==', 'cooperative'),
      limit(1)
    );
    
    const storesSnap = await getDocs(cooperativeQuery);
    
    if (!storesSnap.empty) {
      const store = storesSnap.docs[0];
      return {
        storeId: store.id,
        storeType: 'cooperative',
        storeName: store.data().name || 'Cooperative Store'
      };
    } else {
      // Fallback if no cooperative store found
      return {
        storeId: 'cooperative',
        storeType: 'cooperative',
        storeName: 'Cooperative Store'
      };
    }
  } catch (error) {
    console.error('Error getting cooperative store ID:', error);
    return {
      storeId: 'cooperative',
      storeType: 'cooperative',
      storeName: 'Cooperative Store'
    };
  }
}

/**
 * Get store information by store ID
 */
export async function getStoreInfo(storeId) {
  try {
    if (!storeId) return null;
    
    const storesRef = collection(db, 'stores');
    const storeQuery = query(
      storesRef,
      where('__name__', '==', storeId),
      limit(1)
    );
    
    const storesSnap = await getDocs(storeQuery);
    
    if (!storesSnap.empty) {
      const store = storesSnap.docs[0];
      return {
        storeId: store.id,
        storeType: store.data().type || 'cooperative',
        storeName: store.data().name || 'Unknown Store'
      };
    }
    
    return null;
  } catch (error) {
    console.error('Error getting store info:', error);
    return null;
  }
}

/**
 * Get default store information for product creation
 * This determines which store a product should be associated with
 */
export async function getDefaultStoreInfo() {
  // For now, all products are associated with the cooperative store
  // In the future, this could be enhanced to support different stores
  return await getCooperativeStoreId();
}
